<template>
  <div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-info">
      <b-row>
        <b-col xl="3" md="6">
          <stats-card type="gradient-info" icon="ni ni-chart-bar-32" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">
              JUMLAH SURVEYOR
            </h5>
            <span class="h2 font-weight-bold mb-0">{{ tableData.length }}</span>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <b-row class="mt-2">
              <b-col xl="12" class="mb-5 mb-xl-0">
                <b-card body-class="p-0" header-class="border-0">
                  <template v-slot:header>
                    <b-row align-v="center">
                      <b-col>
                        <h3 class="mb-0">Data Surveyor (Scope Fakultas)</h3>
                        <small class="text-muted">
                          1 fakultas = 1 akun login (otomatis <code>surveyor + kode fakultas</code>),
                          bisa multi-staf biodata.
                        </small>
                      </b-col>
                      <b-col class="text-right">
                        <button @click="exportData()" class="btn btn-sm btn-default">
                          <i class="fa fa-download mr-2"></i>Export Akun
                        </button>
                        <button class="btn btn-sm btn-info" v-b-modal.modal-prevent-closing>
                          <i class="ni ni-fat-add"></i>Tambah Data
                        </button>
                      </b-col>
                    </b-row>
                  </template>

                  <!-- modal create -->
                  <b-modal id="modal-prevent-closing" ref="modal" title="Tambah Surveyor" @show="resetModal"
                    @hidden="resetModal" @ok="handleOk">
                    <form ref="form" @submit.stop.prevent="handleSubmit">
                      <div v-if="message" class="alert alert-danger rounded mb-3" role="alert">{{ message }}</div>

                      <div class="row">
                        <div class="col-12 mb-3">
                          <h4 class="mb-2">Tipe Scope <span class="text-danger">*</span></h4>
                          <b-form-radio-group v-model="surveyor.scope_type" @change="onScopeTypeChange">
                            <b-form-radio value="fakultas">Fakultas (akses semua prodi di fakultas)</b-form-radio>
                            <b-form-radio value="prodi">Prodi (akses 1 prodi saja)</b-form-radio>
                          </b-form-radio-group>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 mb-3">
                          <h4 class="mb-2">Nama <span class="text-danger">*</span></h4>
                          <input v-model="surveyor.name" type="text" class="form-control"
                            placeholder="Nama Surveyor" />
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 mb-3">
                          <h4 class="mb-2">Email <span class="text-danger">*</span></h4>
                          <input v-model="surveyor.email" type="email" class="form-control"
                            placeholder="email@unila.ac.id" />
                          <small class="text-muted">Boleh duplikat antar staf.</small>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 mb-3">
                          <h4 class="mb-2">No. Telp <span class="text-danger">*</span></h4>
                          <input v-model="surveyor.phone" type="tel" class="form-control"
                            placeholder="08xxxxxxxxxx" />
                          <small class="text-muted">Format: diawali 08, 10-15 digit. Tidak unique.</small>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 mb-3">
                          <h4 class="mb-2">Fakultas <span class="text-danger">*</span></h4>
                          <select class="form-select form-control" v-model="surveyor.id_fakultas"
                            @change="loadProdis">
                            <option value="" disabled>---- Pilih Fakultas ----</option>
                            <option v-for="faculty in faculties" :key="faculty.id_fakultas"
                              :value="faculty.id_fakultas">
                              {{ faculty.kode_fakultas }} — {{ faculty.nm_fakultas }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="row" v-if="surveyor.scope_type === 'prodi'">
                        <div class="col-12 mb-3">
                          <h4 class="mb-2">Program Studi <span class="text-danger">*</span></h4>
                          <select class="form-select form-control" v-model="surveyor.id_program_studi">
                            <option value="" disabled>---- Pilih Prodi ----</option>
                            <option v-for="p in study_programs" :key="p.id_program_studi"
                              :value="p.id_program_studi">
                              {{ p.kode_prodi }} — {{ p.jenjang }} {{ p.nm_program_studi }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <div class="login-preview p-3 mb-0 rounded">
                        <div class="text-muted small mb-2 font-weight-bold">Login akun otomatis</div>
                        <div class="row no-gutters">
                          <div class="col-3 text-muted small">Username</div>
                          <div class="col-9">
                            <code class="text-primary">{{ previewUsername || '(pilih ' + (surveyor.scope_type === 'prodi' ? 'prodi' : 'fakultas') + ' dulu)' }}</code>
                          </div>
                        </div>
                        <div class="row no-gutters">
                          <div class="col-3 text-muted small">Password</div>
                          <div class="col-9">
                            <code class="text-primary">{{ previewPassword || '-' }}</code>
                          </div>
                        </div>
                        <div class="text-muted small mt-2" style="font-size: 0.75rem;">
                          Case-insensitive saat login. Akun shared antar staf di scope yang sama.
                        </div>
                      </div>
                    </form>
                  </b-modal>

                  <!-- modal edit -->
                  <b-modal id="modal-edit-surveyor" ref="modalEdit" title="Edit Surveyor" @ok="handleEditOk">
                    <form ref="formEdit" @submit.stop.prevent="handleEditSubmit">
                      <div v-if="editMessage" class="alert alert-danger rounded mb-3" role="alert">{{ editMessage }}</div>

                      <div class="row">
                        <div class="col-12 mb-3">
                          <h4 class="mb-2">Tipe Scope</h4>
                          <b-form-radio-group v-model="editSurveyor.scope_type" @change="onEditScopeTypeChange">
                            <b-form-radio value="fakultas">Fakultas</b-form-radio>
                            <b-form-radio value="prodi">Prodi</b-form-radio>
                          </b-form-radio-group>
                          <small class="text-muted">Mengubah scope akan re-link ke akun login baru.</small>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 mb-3">
                          <h4 class="mb-2">Nama</h4>
                          <input v-model="editSurveyor.name" type="text" class="form-control" />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 mb-3">
                          <h4 class="mb-2">Email</h4>
                          <input v-model="editSurveyor.email" type="email" class="form-control" />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 mb-3">
                          <h4 class="mb-2">No. Telp</h4>
                          <input v-model="editSurveyor.phone" type="tel" class="form-control" placeholder="08xxxxxxxxxx" />
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 mb-3">
                          <h4 class="mb-2">Fakultas</h4>
                          <select class="form-select form-control" v-model="editSurveyor.id_fakultas"
                            @change="loadEditProdis">
                            <option value="" disabled>---- Pilih Fakultas ----</option>
                            <option v-for="faculty in faculties" :key="faculty.id_fakultas"
                              :value="faculty.id_fakultas">
                              {{ faculty.kode_fakultas }} — {{ faculty.nm_fakultas }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row" v-if="editSurveyor.scope_type === 'prodi'">
                        <div class="col-12 mb-3">
                          <h4 class="mb-2">Program Studi</h4>
                          <select class="form-select form-control" v-model="editSurveyor.id_program_studi">
                            <option value="" disabled>---- Pilih Prodi ----</option>
                            <option v-for="p in editStudyPrograms" :key="p.id_program_studi"
                              :value="p.id_program_studi">
                              {{ p.kode_prodi }} — {{ p.jenjang }} {{ p.nm_program_studi }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </form>
                  </b-modal>

                  <div class="padding">
                    <v-client-table :data="tableData" :columns="columns" :options="options">
                      <template slot="actions" slot-scope="{ row }">
                        <button @click="editItem(row)" class="btn btn-sm btn-info mr-1">
                          <i class="ni ni-ruler-pencil"></i>
                        </button>
                        <button @click="deleteItem(row)" class="btn btn-sm btn-danger">
                          <i class="ni ni-fat-remove"></i>
                        </button>
                      </template>
                    </v-client-table>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseHeader from "@/components/admin/BaseHeader";
import DataService from "@/services/data.service";
import Loading from "@/components/Loading.vue";

export default {
  name: "MasterSurveyor",
  components: {
    BaseHeader,
    Loading
  },
  data() {
    return {
      loading: false,
      message: "",
      surveyor: {
        scope_type: "fakultas",
        name: "",
        email: "",
        phone: "",
        id_fakultas: "",
        id_program_studi: ""
      },
      editSurveyor: {
        id_surveyor: "",
        scope_type: "fakultas",
        name: "",
        email: "",
        phone: "",
        id_fakultas: "",
        id_program_studi: ""
      },
      editMessage: "",
      faculties: [],
      study_programs: [],
      editStudyPrograms: [],
      columns: [
        "id_surveyor",
        "nama",
        "email",
        "no_telp",
        "scope_type",
        "nm_fakultas",
        "nm_program_studi",
        "username",
        "actions"
      ],
      tableData: [],
      options: {
        headings: {
          nama: "Nama",
          email: "Email",
          no_telp: "No. Telp",
          scope_type: "Scope",
          nm_fakultas: "Fakultas",
          nm_program_studi: "Prodi",
          username: "Akun (Login)",
          actions: "Aksi"
        },
        sortable: true,
        filterable: true,
        hiddenColumns: ["id_surveyor"],
        texts: {
          count: "Menampilkan {from} sampai {to} dari {count} data|{count} data|Satu data",
          first: "Pertama",
          last: "Terakhir",
          filter: false,
          filterPlaceholder: "Pencarian",
          limit: false,
          page: "Page:",
          noResults: "Data tidak ada",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns"
        },
        sortIcon: {
          is: "fa fa-sort",
          base: "font-awesome",
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          align: "center"
        },
        pagination: { show: true, dropdown: false, chunk: 5, edge: false, align: "center", nav: "fixed" }
      }
    };
  },
  mounted() {
    this.getSurveyors();
    DataService.getFaculties()
      .then(res => {
        this.faculties = res.data.faculties;
      })
      .catch(error => console.error(error));
  },
  computed: {
    previewUsername() {
      if (this.surveyor.scope_type === 'prodi' && this.surveyor.id_program_studi) {
        var p = this.study_programs.find(sp => sp.id_program_studi === this.surveyor.id_program_studi);
        return p ? 'surveyor' + p.kode_prodi : '';
      }
      if (this.surveyor.scope_type === 'fakultas' && this.surveyor.id_fakultas) {
        var f = this.faculties.find(fk => fk.id_fakultas === this.surveyor.id_fakultas);
        return f ? 'surveyor' + f.kode_fakultas : '';
      }
      return '';
    },
    previewPassword() {
      if (this.surveyor.scope_type === 'prodi' && this.surveyor.id_program_studi) {
        var p = this.study_programs.find(sp => sp.id_program_studi === this.surveyor.id_program_studi);
        return p ? p.kode_prodi : '';
      }
      if (this.surveyor.scope_type === 'fakultas' && this.surveyor.id_fakultas) {
        var f = this.faculties.find(fk => fk.id_fakultas === this.surveyor.id_fakultas);
        return f ? f.kode_fakultas : '';
      }
      return '';
    }
  },
  methods: {
    getSurveyors() {
      this.loading = true;
      this.$store.commit("SHOW_LOADING", "Memuat data surveyor...");
      DataService.getSurveyors().then(res => {
        this.tableData = res.data.surveyors || [];
        this.loading = false;
        this.$store.commit("HIDE_LOADING");
      });
    },
    exportData() {
      var self = this;
      self.$store.commit("SHOW_LOADING", "Menyiapkan file export...");
      DataService.exportSurveyors()
        .then(function (response) {
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "surveyors_" + new Date().toISOString().slice(0, 10) + ".xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          self.$store.commit("HIDE_LOADING");
        })
        .catch(function () {
          self.$store.commit("HIDE_LOADING");
          self.$swal({ icon: "error", title: "Gagal mengekspor data" });
        });
    },
    resetModal() {
      this.surveyor.scope_type = "fakultas";
      this.surveyor.name = "";
      this.surveyor.email = "";
      this.surveyor.phone = "";
      this.surveyor.id_fakultas = "";
      this.surveyor.id_program_studi = "";
      this.study_programs = [];
      this.message = "";
    },
    onScopeTypeChange() {
      // Reset prodi pilihan saat ganti tipe.
      this.surveyor.id_program_studi = "";
    },
    onEditScopeTypeChange() {
      this.editSurveyor.id_program_studi = "";
    },
    loadProdis() {
      var idFak = this.surveyor.id_fakultas;
      this.surveyor.id_program_studi = "";
      if (!idFak) { this.study_programs = []; return; }
      DataService.getProgramsChoise(idFak)
        .then(res => { this.study_programs = res.data.studyPrograms || []; })
        .catch(() => { this.study_programs = []; });
    },
    loadEditProdis() {
      var idFak = this.editSurveyor.id_fakultas;
      if (!idFak) { this.editStudyPrograms = []; return; }
      DataService.getProgramsChoise(idFak)
        .then(res => { this.editStudyPrograms = res.data.studyPrograms || []; })
        .catch(() => { this.editStudyPrograms = []; });
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      this.message = "";
      var name = (this.surveyor.name || "").trim();
      var email = (this.surveyor.email || "").trim();
      var phone = (this.surveyor.phone || "").trim();
      var idFak = this.surveyor.id_fakultas;
      var idProdi = this.surveyor.scope_type === "prodi" ? this.surveyor.id_program_studi : null;

      if (!name) { this.message = "Nama wajib diisi"; return; }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { this.message = "Email tidak valid"; return; }
      if (!phone || !/^08[0-9]{8,13}$/.test(phone)) { this.message = "No. telp harus diawali 08 dan 10-15 digit"; return; }
      if (!idFak) { this.message = "Fakultas wajib dipilih"; return; }
      if (this.surveyor.scope_type === "prodi" && !idProdi) { this.message = "Prodi wajib dipilih untuk scope prodi"; return; }

      let data = { name: name, email: email, phone: phone, id_fakultas: idFak, id_program_studi: idProdi };
      DataService.createSurveyor(data)
        .then(res => {
          var info = res.data.login_info;
          this.$swal({
            icon: "success",
            title: "Surveyor ditambahkan",
            html: info
              ? "<small>Akun login (shared per fakultas):</small><br>"
                + "<strong>Username:</strong> <code>" + info.username + "</code><br>"
                + "<strong>Password:</strong> <code>" + info.password + "</code>"
              : "Berhasil disimpan."
          });
          this.getSurveyors();
          this.$nextTick(() => this.$bvModal.hide("modal-prevent-closing"));
        })
        .catch(error => {
          this.message =
            (error.response && error.response.data && error.response.data.message) ||
            error.message || error.toString();
        });
    },
    editItem(row) {
      this.editSurveyor.id_surveyor = row.id_surveyor;
      this.editSurveyor.scope_type = row.scope_type || (row.id_program_studi ? "prodi" : "fakultas");
      this.editSurveyor.name = row.nama || "";
      this.editSurveyor.email = row.email || "";
      this.editSurveyor.phone = row.no_telp || "";
      this.editSurveyor.id_fakultas = row.id_fakultas || "";
      this.editSurveyor.id_program_studi = row.id_program_studi || "";
      this.editStudyPrograms = [];
      this.editMessage = "";
      if (row.id_fakultas) this.loadEditProdis();
      this.$bvModal.show("modal-edit-surveyor");
    },
    handleEditOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleEditSubmit();
    },
    handleEditSubmit() {
      var data = {
        name: this.editSurveyor.name,
        email: this.editSurveyor.email,
        phone: this.editSurveyor.phone,
        id_fakultas: this.editSurveyor.id_fakultas,
        id_program_studi: this.editSurveyor.scope_type === "prodi" ? this.editSurveyor.id_program_studi : null
      };
      DataService.updateSurveyor(this.editSurveyor.id_surveyor, data)
        .then(() => {
          this.getSurveyors();
          this.$bvModal.hide("modal-edit-surveyor");
        })
        .catch(error => {
          this.editMessage =
            (error.response && error.response.data && error.response.data.message) ||
            error.message || error.toString();
        });
    },
    deleteItem(row) {
      this.$swal({
        title: "Hapus surveyor permanen?",
        html: "Biodata <strong>" + row.nama + "</strong> akan dihapus permanen.<br>"
          + "<small>Akun fakultas otomatis dihapus jika ini staf terakhir di fakultas tersebut.</small>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Ya, hapus permanen",
        cancelButtonText: "Batal"
      }).then(result => {
        if (result.value) {
          DataService.deleteSurveyor(row.id_surveyor)
            .then(() => {
              this.$swal("Data berhasil dihapus");
              this.getSurveyors();
            })
            .catch(() => {
              this.$swal({ icon: "error", title: "Terjadi kesalahan" });
              this.getSurveyors();
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.padding {
  padding: 20px !important;
}
.login-preview {
  background: #f6f9fc;
  border: 1px solid #e9ecef;
}
.login-preview code {
  background: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  font-size: 0.85rem;
}
</style>
